import { useState } from 'react'
import { getWinner } from '../utils/challenges'
import { IconTrophy, IconClapper, IconTarget, IconShare, IconSwords, IconCheck, IconActor, IconActress } from './icons'

const fmt = (s) => {
  if (s == null) return '--:--'
  const m = Math.floor(s / 60).toString().padStart(2, '0')
  const ss = (s % 60).toString().padStart(2, '0')
  return `${m}:${ss}`
}

function buildChainIcons(chain) {
  if (!chain) return null
  return chain.map((item, i) => {
    const Icon = item.type === 'movie' ? IconClapper
      : i === chain.length - 1 ? IconTrophy
      : item.gender === 1 ? IconActress : IconActor
    return (
      <span key={i} className="h2h-results__chain-node">
        {i > 0 && ' → '}
        <Icon size={14} style={{ verticalAlign: 'middle' }} />
      </span>
    )
  })
}

export default function H2HResults({ challenge, myRole, onRematch, onHome }) {
  const [toast, setToast] = useState(false)

  const winner = getWinner(challenge)
  const p1 = challenge.player1Result
  const p2 = challenge.player2Result
  const p1Name = challenge.player1?.username || 'Player 1'
  const p2Name = challenge.player2?.username || 'Player 2'
  const winnerName = winner === 1 ? p1Name : winner === 2 ? p2Name : null

  const handleShare = () => {
    const winnerLabel = winner === 0 ? "It's a tie!" : `${winnerName} wins in ${winner === 1 ? p1?.moves : p2?.moves} hops 🏆`
    const text = `Action! ⚔️ ${p1Name} vs ${p2Name} — ${winnerLabel}`
    navigator.clipboard?.writeText(text).catch(() => {})
    setToast(true)
    setTimeout(() => setToast(false), 2000)
  }

  const PlayerCard = ({ result, name, role }) => {
    const isWinner = (role === 'p1' && winner === 1) || (role === 'p2' && winner === 2)
    const isMe = role === myRole
    return (
      <div className={`h2h-results__player ${isWinner ? 'h2h-results__player--winner' : ''}`}>
        {isWinner && <span className="h2h-results__crown"><IconTrophy size={18} /></span>}
        <p className="h2h-results__name">{name}{isMe ? ' (you)' : ''}</p>
        <p className="h2h-results__score">{result?.moves ?? '—'} hops</p>
        <p className="h2h-results__time">{fmt(result?.timeSeconds)}</p>
        {result?.hintsUsed > 0 && (
          <p className="h2h-results__hints">{Array.from({ length: result.hintsUsed }).map((_, i) => <IconClapper key={i} size={13} style={{ verticalAlign: 'middle' }} />)} Cut{result.hintsUsed > 1 ? 's' : ''} used</p>
        )}
        <p className="h2h-results__chain">{buildChainIcons(result?.chain)}</p>
      </div>
    )
  }

  return (
    <div className="h2h-results">
      <div className={`toast ${toast ? 'toast--visible' : ''}`}>Copied! <IconCheck size={14} style={{ verticalAlign: 'middle' }} /></div>

      <div className="h2h-results__content">
        {winner === 0 ? (
          <p className="h2h-results__headline">It's a tie! <IconClapper size={16} style={{ verticalAlign: 'middle' }} /></p>
        ) : (
          <p className="h2h-results__headline">
<IconTrophy size={18} style={{ verticalAlign: 'middle' }} /> {winnerName} wins!
          </p>
        )}

        <p className="h2h-results__goal">
<IconTarget size={15} style={{ verticalAlign: 'middle' }} /> Goal: {challenge.goalActor?.name}
        </p>

        <div className="h2h-results__grid">
          <PlayerCard result={p1} name={p1Name} role="p1" />
          <PlayerCard result={p2} name={p2Name} role="p2" />
        </div>

        <div className="h2h-results__actions">
          <button className="btn-primary" onClick={handleShare}>Share Result <IconShare size={15} style={{ verticalAlign: 'middle' }} /></button>
          <button className="btn-primary" onClick={onRematch}>Rematch <IconSwords size={15} style={{ verticalAlign: 'middle' }} /></button>
          <button className="btn-ghost" onClick={onHome}>Home</button>
        </div>
      </div>
    </div>
  )
}
